// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as IncentiveDashboardCmp from "./components/IncentiveDashboardCmp.bs.js";
import * as IncentiveAssetsManager from "./assets/styles/IncentiveAssetsManager.bs.js";

IncentiveAssetsManager.importCss(undefined);

function IncentiveDashboardWrapper(Props) {
  var msisdn = Props.msisdn;
  var auth_token = Props.auth_token;
  var language = Props.language;
  return React.createElement(IncentiveDashboardCmp.make, {
              msisdn: msisdn,
              auth_token: auth_token,
              language: language
            });
}

var make = IncentiveDashboardWrapper;

export {
  make ,
  
}
/*  Not a pure module */
